var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "144.51mm",
    height: "144.51mm",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M 98.00,0.11            C 84.08,2.53 71.56,5.63 59.00,12.32              25.36,30.26 0.06,67.21 0.00,106.00              0.00,106.00 0.00,406.00 0.00,406.00              0.09,461.30 50.70,511.91 106.00,512.00              106.00,512.00 406.00,512.00 406.00,512.00              461.30,511.91 511.91,461.30 512.00,406.00              512.00,406.00 512.00,106.00 512.00,106.00              511.91,50.70 461.30,0.09 406.00,0.11              406.00,0.11 202.00,0.11 202.00,0.11              202.00,0.11 135.00,0.11 135.00,0.11              135.00,0.11 98.00,0.11 98.00,0.11 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M 244.00,159.28            C 271.04,156.77 296.74,163.03 318.00,180.46              359.45,214.44 365.85,279.65 329.83,320.00              320.92,329.98 310.97,337.76 299.00,343.73              281.61,352.40 267.85,353.22 249.00,353.00              214.79,352.60 180.19,326.91 166.87,296.00              159.43,278.73 158.97,269.26 159.00,251.00              159.05,215.78 183.34,181.70 215.00,167.31              224.60,162.95 233.65,160.80 244.00,159.28 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJa);
export default __webpack_public_path__ + "static/media/ja.e43ef2227b612ef9e506ac9850392d09.svg";
export { ForwardRef as ReactComponent };